import MarcaForm from './MarcaForm'
export {MarcaForm}
export default MarcaForm
